
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/partners/[state]/[destination]/[slug]/[partnerId]",
      function () {
        return require("private-next-pages/partners/[state]/[destination]/[slug]/[partnerId].ts");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/partners/[state]/[destination]/[slug]/[partnerId]"])
      });
    }
  